module.exports = "/assets/c6c90b34760c568c1a7e8b5c40a359a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VJ.png
// module id = 3047
// module chunks = 0